module.exports = __webpack_public_path__ + "img/warn-modal.0c739379.svg";